/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@apollo/client';
import { Tooltip } from 'antd';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import IconComponent from 'components/common/IconComponent';
import React, { SyntheticEvent } from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';
import { CREATE_TRANSACTION } from 'services/graphql/mutations/transactions';
import { ITransaction } from 'types/transaction';
import { defaultNotification, getLink } from 'utils';

const CloneTransactionButton: React.FC<{ cloneTransaction?: ITransaction }> = ({ cloneTransaction }) => {
  const history = useHistory();
  const [createTransaction, { loading }] = useMutation<{ createTransactionEntity: ITransaction }>(CREATE_TRANSACTION);

  const onCloneTransactionClick = async (e: SyntheticEvent) => {
    e.stopPropagation();
    if (!cloneTransaction) return;

    const clonedAppointments = cloneTransaction.appointment?.map((appt) => {
      const {
        id,
        notary,
        assignments,
        clientInPersonFee,
        clientRONFee,
        notaryGetInPerson,
        notaryGetRON,
        status,
        fileIds,
        files,
        ...restAppointment
      } = appt;
      return restAppointment;
    });

    const newTransactionByClone = {
      reference: cloneTransaction.reference,
      description: cloneTransaction.description,
      signatories: cloneTransaction.signatories,
      transactionType: cloneTransaction.transactionType.id,
      appointments: clonedAppointments,
    };

    try {
      const result = await createTransaction({ variables: { doc: newTransactionByClone } });
      const newTransactionId = result?.data?.createTransactionEntity.id;
      history.push({
        pathname: getLink(ROUTES.TRANSACTION_DETAIL, { id: newTransactionId || '' }),
      });
    } catch (err) {
      console.log('ERROR', err);
      defaultNotification({ failure: 'Cloning transaction failed! Please try again' });
    }
  };
  return (
    <Tooltip title='Clone this transaction'>
      <div className='gx-d-inline-block'>
        <ButtonWithSpinner
          isLoading={loading}
          onClick={onCloneTransactionClick}
          bgColorOnHover='transparent'
          borderColorOnHover='transparent'
          buttonType='text'
          width='auto'
          height='18px'>
          <IconComponent name='copy' color='#038fdd' />
        </ButtonWithSpinner>
      </div>
    </Tooltip>
  );
};

export default React.memo(CloneTransactionButton);
